import React, {useState } from "react";

import { Container, InputText, ImgLupa, SelectEspcialidade } from "./styles";

import {Agenda, TipoEvento} from "../../../../data/interfaces";

interface OwnProps {
  cadastros : Agenda[];
  cadastrosTmp: Agenda[];
  onChange: Function;
}
type Props = OwnProps;

export default function Busca({cadastros, cadastrosTmp, onChange}:Props) {
  const [tipoEscolhida, setTipoEscolhida] = useState<string>("Todos")
  const [chave, setChave] = useState<string>("");

  

  function handleBuscar() {
    const busca:Agenda[] = cadastros.filter( ({tipo, descricao }) =>  tipo === tipoEscolhida && descricao.toUpperCase().includes(chave.toUpperCase()) )
    if(busca.length > 0 ){
      onChange(busca);
    }else{
      onChange(cadastrosTmp);
    }
    setChave("");
  }

  return (
    <Container>
      <InputText type="text" value={chave} onChange={(value: React.ChangeEvent<HTMLInputElement>)=>setChave(value.target.value)} placeholder="Busca ..." />
      <SelectEspcialidade value={tipoEscolhida} onChange={(
                ev: React.ChangeEvent<HTMLSelectElement>,
            ): void => setTipoEscolhida(ev.target.value)} id="selectEspecialidades">
        <option value="Todos">Todos</option>
        <option value={TipoEvento.ANIVERSARIO}>{TipoEvento.ANIVERSARIO}</option>
        <option value={TipoEvento.CURSO}>{TipoEvento.CURSO}</option>
        <option value={TipoEvento.EVENTO}>{TipoEvento.EVENTO}</option>
        <option value={TipoEvento.FEIRA}>{TipoEvento.FEIRA}</option>
        <option value={TipoEvento.FERIADO}>{TipoEvento.FERIADO}</option>
        <option value={TipoEvento.OUTROS}>{TipoEvento.OUTROS}</option>
      </SelectEspcialidade>
      <ImgLupa onClick={()=>{handleBuscar()}} />
    </Container>
  );
}
